import { useMutation, useQueryClient } from '@tanstack/react-query';
import preciosService from '../services/preciosService';
import { preciosKeys } from '../queryKeys';

const useActualizarPrecio = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ idcentro, codigocurso, cambios }) =>
      preciosService.actualizarPrecio({ headquarter, idcentro, codigocurso, cambios }),
    onSuccess: () => qc.invalidateQueries({ queryKey: preciosKeys.listas(headquarter) }),
  });
};

export default useActualizarPrecio;
